export enum TypeNotifications {
    INCREASE = 'increase',
    EXPIRED = 'expired',
    NEWS = 'news',
    OBSERVATIONS = 'observations',
}
